export const ADD_ERROR = 'ADD_ERROR';
export const REMOVE_ERROR = 'REMOVE_ERROR';
export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const LOAD_MESSAGES = 'LOAD_MESSAGES';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
export const SAVE_FILE = 'SAVE_FILE';
export const ADD_EXERCISE = 'ADD_EXERCISE';
export const EDIT_EXERCISE = 'EDIT_EXERCISE';
export const FETCH_TRAINER_EXERCISES = 'FETCH_TRAINER_EXERCISES';
export const FETCH_FAVOURITE_EXERCISES = 'FETCH_FAVOURITE_EXERCISES';
export const FETCH_CORPORATE_EXERCISES = 'FETCH_CORPORATE_EXERCISES';
export const FETCH_EXERCISE_CATEGORIES = 'FETCH_EXERCISE_CATEGORIES'
export const FETCH_TRAINER_EXERCISE_CATS = 'FETCH_TRAINER_EXERCISE_CATS'
export const FETCH_CORPORATE_EXERCISE_CATS = 'FETCH_CORPORATE_EXERCISE_CATS'
export const RESET_EXERCISES_LISTING = 'RESET_EXERCISES_LISTING';
export const RESET_EXERCISE_FILTER = 'RESET_EXERCISE_FILTER';
export const SET_EXERCISE_SEARCH_TERM = 'SET_EXERCISE_SEARCH_TERM';
export const SET_EXCERCISE_FILTER = "SET_EXCERCISE_FILTER";
export const UPDATE_EXERCISES_FAVOURITE = "UPDATE_EXERCISES_FAVOURITE";
export const SET_EXERCISES_LOAD_MORE = "SET_EXERCISES_LOAD_MORE";
export const ADD_INSTRUCTION = 'ADD_INSTRUCTION';
export const EDIT_INSTRUCTION = 'EDIT_INSTRUCTION';
export const FETCH_TRAINER_INSTRUCTIONS = 'FETCH_TRAINER_INSTRUCTIONS';
export const ADD_EXERCISE_CAT = 'FETCH_CORPORATE_EXERCISE_CATS'
export const FETCH_FILES = 'FETCH_FILES';
export const RESET_FILES = 'RESET_FILES';
export const FETCH_EXERCISE_VIDEOS = 'FETCH_EXERCISE_VIDEOS';
export const FETCH_CORPORATE_WORKOUTS = 'FETCH_CORPORATE_WORKOUTS';
export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';
export const ADD_PARTNER = 'ADD_PARTNER';
export const FETCH_WORKOUT_CATS = 'FETCH_WORKOUT_CATS';
export const FETCH_WORKOUTS = 'FETCH_WORKOUTS';
export const UPDATE_ORDER_WORKOUTS = 'UPDATE_ORDER_WORKOUTS';
export const FETCH_INDIVIDUAL_PROGRAM_WORKOUTS = 'FETCH_INDIVIDUAL_PROGRAM_WORKOUTS';
export const RESET_WORKOUTS = 'RESET_WORKOUTS';
export const FETCH_WORKOUT_INFO = 'FETCH_WORKOUT_INFO';
export const FETCH_PROGRAM_INFO = 'FETCH_PROGRAM_INFO';
export const RESET_WORKOUT_INFO = 'RESET_WORKOUT_INFO';
export const RESET_PROGRAM_INFO = 'RESET_PROGRAM_INFO';
export const FETCH_BLOCK_INFO = 'FETCH_BLOCK_INFO';
export const FETCH_BLOCKS = 'FETCH_BLOCKS';
export const RESET_BLOCKS = 'RESET_BLOCKS';
export const RESET_PROGRAMS = 'RESET_PROGRAMS';
export const RESET_CLIENTS = 'RESET_CLIENTS';
export const RESET_GROUPS = 'RESET_GROUPS';
export const FETCH_MY_WORKOUTS = 'FETCH_MY_WORKOUTS';
export const FETCH_PROGRAM_CATS = 'FETCH_PROGRAM_CATS';
export const FETCH_BLOCK_CATS = 'FETCH_BLOCK_CATS';
export const FETCH_INSTRUCTION_CATS = 'FETCH_INSTRUCTION_CATS';
export const FETCH_EXERCISE_CATS = 'FETCH_EXERCISE_CATS';
export const FETCH_PROGRAMS = 'FETCH_PROGRAMS';
export const UPDATE_ORDER_PROGRAMS = 'UPDATE_ORDER_PROGRAMS';
export const FETCH_ITEMS = 'FETCH_ITEMS';
export const FETCH_FEATURED_BRANDS = 'FETCH_FEATURED_BRANDS';
export const FETCH_SEQUENCES = 'FETCH_SEQUENCES';
export const FETCH_EXERCISES = 'FETCH_EXERCISES';
export const FETCH_CIRCUITS = 'FETCH_CIRCUITS';
export const FETCH_PLANS = 'FETCH_PLANS';
export const FETCH_EQUIPMENT = 'FETCH_EQUIPMENT';
export const FETCH_PROGRAM_DAYS = 'FETCH_PROGRAM_DAYS';
export const FETCH_PARTNERS = 'FETCH_PARTNERS';
export const FETCH_TRAINER_WORKOUTS = 'FETCH_TRAINER_WORKOUTS';
export const FETCH_GROUPS = 'FETCH_GROUPS';
export const FETCH_CLIENTS = 'FETCH_CLIENTS';
export const FETCH_PARTNER_ASSIGNMENTS = 'FETCH_PARTNER_ASSIGNMENTS';
export const FETCH_EMAIL_ASSIGNMENTS = 'FETCH_EMAIL_ASSIGNMENTS';
export const FETCH_ALL_CATEGORIES = 'FETCH_ALL_CATEGORIES';
export const UPDATE_PARTNER_ASSIGNMENTS = 'UPDATE_PARTNER_ASSIGNMENTS';
export const UPDATE_USER = 'UPDATE_USER';
export const ADD_GROUP = 'ADD_GROUP';
export const ADD_CLIENT = 'ADD_CLIENT';
export const FETCH_STATEMENTS = 'FETCH_STATEMENTS';
export const FETCH_INVOICES = 'FETCH_INVOICES';
export const FETCH_DASHBOARD = 'FETCH_DASHBOARD';
export const FETCH_BRAND = 'FETCH_BRAND';
export const FETCH_REFERENCE_DETAIL = 'FETCH_REFERENCE_DETAIL';
export const FETCH_ALL_BRANDS = 'FETCH_ALL_BRANDS';
export const FETCH_ALL_NCEP_TRAINER_BRANDS = 'FETCH_ALL_NCEP_TRAINER_BRANDS';
export const FETCH_ALL_TRAINER_BRANDS = 'FETCH_ALL_TRAINER_BRANDS';


export const UPDATE_BRAND = 'UPDATE_BRAND';
export const CREATE_BRAND = 'CREATE_BRAND';
export const DELETE_BRAND = 'DELETE_BRAND';
export const CHANGE_BRAND_ORDER = 'CHANGE_BRAND_ORDER';
export const CREATE_BRAND_EQUIPMENT = 'CREATE_BRAND_EQUIPMENT';
export const UPDATE_BRAND_EQUIPMENT = 'UPDATE_BRAND_EQUIPMENT';
export const FETCH_BRAND_EQUIPMENT = 'FETCH_BRAND_EQUIPMENT';
export const FETCH_REVENUE_BREAKDOWN = 'FETCH_REVENUE_BREAKDOWN';
export const START_LOADER = 'START_LOADER';
export const STOP_LOADER = 'STOP_LOADER';
export const GET_CLIENT_PAYMENT_TOKEN = 'GET_CLIENT_PAYMENT_TOKEN';
export const CLEAR_CLIENT_PAYMENT_TOKEN = 'CLEAR_CLIENT_PAYMENT_TOKEN';
export const FETCH_STORE_PRODUCTS = 'FETCH_STORE_PRODUCTS';

export const ADD_AUTOMATION = 'ADD_AUTOMATION';
export const EDIT_ADD_AUTOMATION = 'EDIT_ADD_AUTOMATION';
export const FETCH_AUTOMATIONS = 'FETCH_AUTOMATIONS';
export const RESET_AUTOMATIONS = 'RESET_AUTOMATIONS';


// WEBPACK FOOTER //
// ./src/store/actionTypes.js